/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsshowevidence3Inputs */

const en_openquestionsshowevidence3 = /** @type {(inputs: Openquestionsshowevidence3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show evidence`)
};

const pt_openquestionsshowevidence3 = /** @type {(inputs: Openquestionsshowevidence3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar evidência`)
};

/**
* | output |
* | --- |
* | "Show evidence" |
*
* @param {Openquestionsshowevidence3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsshowevidence3 = /** @type {((inputs?: Openquestionsshowevidence3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsshowevidence3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsshowevidence3(inputs)
	return pt_openquestionsshowevidence3(inputs)
});
export { openquestionsshowevidence3 as "openQuestionsShowEvidence" }